module.exports = __webpack_public_path__ + "img/house-blank.e18cbae1.svg";